import { Reducer } from 'redux';
import { IReduxAction } from 'app/types/actions';
import { GlobalActionTypes as types, IGlobalState } from './types';

const initialState: IGlobalState = {
  isLoading: false,
  hasLoaded: false,
};

const reducer: Reducer<IGlobalState> = (
  state = initialState,
  action: IReduxAction,
) => {
  switch (action.type) {
    case types.GLOBAL_LOAD_PENDING:
      return {
        isLoading: true,
        hasLoaded: false,
      };
    case types.GLOBAL_LOAD_FINISHED:
      return {
        isLoading: false,
        hasLoaded: true,
      };
    default:
      return state;
  }
};

export default reducer;
